// extracted by mini-css-extract-plugin
export default {"DleRecordType":"DleRecordType_DleRecordType__wBV9l","MenuBar":"DleRecordType_MenuBar__g9CXd"};